import CrmServiceModel from "@/models/CrmServiceModel";
import CustomerModel from "@/models/crm/CustomerModel";
import CustomerContactCollection from "../../collections/crm/CustomerContactCollection";

export default class CustomerLocationModel extends CrmServiceModel {

  modelName() {
    return 'customer-locations';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.create = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' /*+'public/' */+ this.modelName();
    routes.exists = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/public/' + this.modelName() + '/exists';
    return routes;
  }

  defaults() {
    return {
      id: null,
      customer_id: null,
      customer: null,
      street_address: null,
      city: null,
      region: null,
      country: null,
      postal_code: null,
      type: null,
      is_primary: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      customer_contacts: [],
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      street_address: (val) => (this.nullStringMutator(val)),
      city: (val) => (this.nullStringMutator(val)),
      region: (val) => (this.nullStringMutator(val)),
      country: (val) => (this.nullStringMutator(val)),
      postal_code: (val) => (this.nullStringMutator(val)),
      type: (val) => (this.nullStringMutator(val)),
      is_primary: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getCustomerContacts() {
    return this.getRelatedCollection(new CustomerContactCollection(), 'customer_contacts');
  }

  getCustomer() {
    return this.getRelatedModel(CustomerModel, 'customer');
  }

  isPrimary() {
    return +(this.is_primary) === 1;
  }

}
